import { IIsGoogleFileCreatingSetAction } from './types';
import { AT_IS_GOOGLE_FILE_CREATING } from './constants';

export const isGoogleFileCreatingSetAction = (
    isGoogleFileCreating: boolean
): IIsGoogleFileCreatingSetAction => ({
    type: AT_IS_GOOGLE_FILE_CREATING,
    isGoogleFileCreating
});
